<div class="consultation-ordered-modal">
  <div class="consultation-ordered-modal__icon">
    <i class="fsi fsi-subtract"></i>
  </div>

  <div class="consultation-ordered-modal__title">
    Спасибо за ваш запрос! <br />
    Наш специалист свяжется с вами в ближайшее время.
  </div>
</div>
